var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArchive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#151A30",
    d: "M3.25 19.286c0 .671.559 1.214 1.25 1.214h15c.691 0 1.25-.543 1.25-1.214V8.357H3.25v10.929zM9.5 11.24c0-.25.21-.455.469-.455h4.062c.258 0 .469.205.469.455v.304c0 .25-.21.455-.469.455H9.97a.464.464 0 01-.469-.455v-.304zM20.75 3.5H3.25C2.559 3.5 2 4.043 2 4.714v1.822c0 .334.281.607.625.607h18.75A.618.618 0 0022 6.536V4.714c0-.671-.559-1.214-1.25-1.214z"
  }))));
}

export default SvgArchive;